import { render } from "./AddAttachmentsFormHosPal.vue?vue&type=template&id=ec6af4f2&ts=true"
import script from "./AddAttachmentsFormHosPal.ts?vue&type=script&lang=ts&external"
export * from "./AddAttachmentsFormHosPal.ts?vue&type=script&lang=ts&external"

import "./AddAttachmentsFormHosPal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__